import React from 'react';
import ModalCustom from 'components/ModalCustom';
import { Stack, Typography } from '@mui/material';
import Button from 'components/Button';

interface Props {
  handleClose: () => void;
  openModal: boolean;
  onConfirm: () => void;
}

const ModalConfirmBranchChange: React.FC<Props> = ({
  handleClose,
  openModal,
  onConfirm,
}) => {
  return (
    <>
      <ModalCustom
        modal={openModal}
        handleClose={handleClose}
        title={'Confirm Branch Change'}
        content={
          <>
            <Stack
              sx={{
                height: { xs: 'auto' },
                width: { xs: 'auto', md: '600px' },
                paddingX: '24px',
                marginBottom: '24px',
                justifyContent: 'space-between',
                maxHeight: '550px',
              }}
              spacing={1}
            >
              <Stack gap={1}>
                <Typography>
                  Changing this member&apos;s branch will also update analytics
                  dashboards and historical monthly snapshots (enrolled members,
                  engagement, message response rates) for both branches will
                  refresh automatically.
                </Typography>
                <Typography>
                  Based on your branch permissions, you may lose access to this
                  member after the change.
                </Typography>
                <Typography>Are you sure you want to continue?</Typography>
              </Stack>
            </Stack>
          </>
        }
        groupButton={
          <Stack
            direction={'row'}
            sx={{
              paddingBottom: '24px',
              paddingRight: '24px',
              justifyContent: 'end',
            }}
            spacing={'12px'}
          >
            <Button
              onClick={handleClose}
              sx={{
                fontWeight: 700,
                fontSize: '14px',
                lineHeight: '20px',
                width: '97px',
                height: '40px',
                border: 'none',
              }}
              variant="text"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              sx={{
                fontWeight: 700,
                fontSize: '14px',
                width: '97px',
                height: '40px',
                lineHeight: '20px',
              }}
              onClick={() => onConfirm()}
            >
              Confirm
            </Button>
          </Stack>
        }
      />
    </>
  );
};

export default ModalConfirmBranchChange;
